// extracted by mini-css-extract-plugin
export default {"container":"omET1hOftJermbkwTmq8","dotted":"cNrLRRnLH4rxIaGHVOze","description":"NLTeTLYXymznteO2Ahhu"};